import { Component, OnInit, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
//import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiserviceService } from 'src/app/core/services/apiservice.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {

  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;
  yetkili_isim:string;
  birimadi:string;
  mevcut:string;
  sifre:string;
  sifre_tekrar:string;
  user:any;
  @ViewChild('sifre_modal') sifre_modal : any;
  constructor(@Inject(DOCUMENT) private document: any, private router: Router, 
              private authFackservice: AuthfakeauthenticationService,
              public _cookiesService: CookieService,private modalService: NgbModal,private api:ApiserviceService) {
  }


  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {

    
    
    this.user = JSON.parse(sessionStorage.getItem('currentUser'));
    this.yetkili_isim=this.user.data[0].per_isim+" "+this.user.data[0].per_soyisim;
     this.birimadi=JSON.parse(sessionStorage.getItem('kurum_sec')).data[0].okul;
     console.log(this.birimadi)

   
  }

  
  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
   
    this.authFackservice.logout();
    this.router.navigate(['/account/login']);
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
    sifremodal(){
    this.modalService.open(this.sifre_modal, { size: 's', centered: true });
  }

  sifre_degistir(){
    console.log(this.user)
    if(this.mevcut==this.user.data[0].sifre){
      if(this.sifre.length>7 && this.sifre_tekrar.length>7){
        if(this.sifre==this.sifre_tekrar ){
          
          

          Swal.fire({
            title: 'Şifreniz Değiştirilecek Onaylıyor musunuz?',
            text: "Onaylıyor musun?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText:'İptal',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet'
          }).then((result) => {
            if (result.isConfirmed) {
              const sifre={
                id:this.user.data[0].id,
                sifre:this.sifre
              }
              
              this.api.post('user/editList', sifre).then((datas) => {
                
                Swal.fire(
                  {
                    title: 'Başarılı',
                     text: "Şifreniz Başarılı Bir Şekilde Değiştirilmiştir.",
                     icon: 'success',
                     confirmButtonText: 'Tamam'
                  }
                )
                this.modalService.dismissAll();
                this.logout();
              });
            }
          });
        }else{
          Swal.fire(
            {
              title: 'Hata',
               text: "Yeni Şifreniz ve Şifre Tekrarı Aynı Değil",
               icon: 'error',
               confirmButtonText: 'Tamam'
            }
          )
        }
      }else{
        Swal.fire(
          {
            title: 'Hata',
             text: "Şifreniz En Az 8 Karakter Olmalı",
             icon: 'error',
             confirmButtonText: 'Tamam'
          }
        )
      }
    }else{
      Swal.fire(
        {
          title: 'Hata',
           text: "Mevcut Şifreniz Hatalı",
           icon: 'error',
           confirmButtonText: 'Tamam'
        }
      )
    }
  }
}
